// @flow

/**
 * Zamezeni vicenasobnemu odeslani formulare (cili na vsechny elementy form, resp. type="submit" tlacitka)
 * Deprecated - pouzijte komponentu Form
 */
export default (targetForm): void => {
  document.body.addEventListener('submit', (event) => {
    const targetElement = event.target;

  if (!targetElement.matches(targetForm)) return;

  const submitElements = targetElement.querySelectorAll('[type="submit"]');

  setTimeout(() => {
    if (submitElements) {
      submitElements.forEach((submitElement) => {
        submitElement.setAttribute('disabled', 'disabled');
    });
    }
  },1)
}, false);
};



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/src/components/PreventMultipleFormSubmit.js